import React from 'react'

const ClasscardSkeleton = () => {
    return (
        <>
            {[...Array(6)].map((item) => (
                <div
                    key={item}
                    className="h-[220px] px-5 rounded-3xl flex justify-center items-center gap-10 bg-gray-100 animate-pulse"
                >
                    <div className="w-[120px] h-[120px] sm:h-[60px] rounded-xl bg-gray-200"></div>
                    <div className="flex-1">
                        <div className="h-6 w-48 bg-gray-200 rounded-lg"></div>
                        <div className="flex gap-2 items-center mt-3">
                            <div className="h-4 w-20 bg-gray-200 rounded-lg"></div>
                            <div className="h-4 w-4 bg-gray-200 rounded-full"></div>
                            <div className="h-4 w-20 bg-gray-200 rounded-lg"></div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}

export default ClasscardSkeleton